import vcMsgeif from './src/vc-msgeif'

vcMsgeif.install = function (Vue) {
  Vue.component(vcMsgeif.name, vcMsgeif)
}

export default vcMsgeif
